import React from "react";
import { LoginContainer } from "modules";
import RegisterContainer from "modules/Authentication/containers/RegisterContainer/RegisterContainer";

type Props = {};

const Register = (props: Props) => {
  return <RegisterContainer />;
};

export default Register;
